import { jsx as s, jsxs as p } from "react/jsx-runtime";
import { c as g } from "react/compiler-runtime";
import { DialogTitle as u, DialogContent as y, Typography as D, Button as f, DialogActions as x, Dialog as C } from "@mui/material";
import { dialogStyles as b } from "../styles.js";
const j = (h) => {
  const e = g(14), {
    open: d,
    onClose: o,
    onConfirm: m
  } = h;
  let n, r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = {
    "& .MuiDialog-paper": b.resetDialog.paper
  }, r = /* @__PURE__ */ s(u, { children: "Reset Map Overlay" }), e[0] = n, e[1] = r) : (n = e[0], r = e[1]);
  let a;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ s(y, { children: /* @__PURE__ */ p(D, { children: [
    "You will need to re-upload the floor plan and RF plan to add it back. ",
    `
`,
    "Do you want to proceed?"
  ] }) }), e[2] = a) : a = e[2];
  let t;
  e[3] !== o ? (t = /* @__PURE__ */ s(f, { onClick: o, children: "Cancel" }), e[3] = o, e[4] = t) : t = e[4];
  let l;
  e[5] !== m ? (l = /* @__PURE__ */ s(f, { onClick: m, color: "primary", variant: "contained", children: "Reset" }), e[5] = m, e[6] = l) : l = e[6];
  let i;
  e[7] !== t || e[8] !== l ? (i = /* @__PURE__ */ p(x, { children: [
    t,
    l
  ] }), e[7] = t, e[8] = l, e[9] = i) : i = e[9];
  let c;
  return e[10] !== o || e[11] !== d || e[12] !== i ? (c = /* @__PURE__ */ p(C, { open: d, onClose: o, maxWidth: "xs", fullWidth: !0, container: document.body, sx: n, children: [
    r,
    a,
    i
  ] }), e[10] = o, e[11] = d, e[12] = i, e[13] = c) : c = e[13], c;
};
export {
  j as ResetDialog
};
